import React from 'react'
import Gamess from '../data/games.json'
import { Swiper, SwiperSlide } from "swiper/react";
import { Autoplay, Pagination, Navigation } from "swiper";
import "swiper/css";
import "swiper/css/pagination";
import "swiper/css/navigation";




export default function Correctpeshbini() {

  const peshbini = JSON.parse(localStorage.getItem('peshbiniakan'));


  return (
    <>

      <div className=" flex w-full mx-auto h-96 bg-dwam ">

        <Swiper
          spaceBetween={30}
          centeredSlides={true}
          autoplay={{
            delay: 2500,
            disableOnInteraction: false,
          }}
          // pagination={{
          //   clickable: true,
          // }}
          navigation={true}
          modules={[Autoplay, Pagination, Navigation]}
          className="mySwiper md:w-full shadow-lg p-3 "
        >

          {
            peshbini ?
              (
                peshbini.map((peshbini) => {

                  const game = Gamess[peshbini.id - 1]

                  if (peshbini.result === game.result) {
                    return (
                      <>
                        <SwiperSlide >
                          <div className='  p-6 space-y-2'>
                            <p className='text-shasham text-center text-xl '>پێشبینیە ڕاستەکان</p>
                            <div className='flex justify-center'>

                              <img className='w-40 h-40 md:w-52 md:h-52 object-contain rounded-full' src={peshbini.userImage} alt='dd' />
                            </div>
                            <div className=''>
                              <p className='text-center text-lg md:text-xl text-shasham '>{peshbini.username}</p>
                              <p className='text-center text-shasham'>{peshbini.team1} {peshbini.peshT1}-{peshbini.peshT2} {peshbini.team2}</p>
                            </div>
                          </div>
                        </SwiperSlide>
                      </>
                    )
                  }
                  else {

                    return null
                  }



                })
              )
              :
              (
                null
              )

          }

        </Swiper>
      </div>


    </>
  )
}
